import { render } from "./OffsetControl.vue?vue&type=template&id=85874434&scoped=true"
import script from "./OffsetControl.vue?vue&type=script&lang=js"
export * from "./OffsetControl.vue?vue&type=script&lang=js"

import "./OffsetControl.vue?vue&type=style&index=0&id=85874434&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85874434"]])

export default __exports__